import { ACCESS_TYPES, KENNEL_STATUSES, PLAYGROUP_STATUSES } from '../../utils'
import _ from 'lodash'

const initialState = {
	facilities: null,
	capacity: {
		dates: {}
	},
	staff: null,
	selected: null,
	selected_playgroup: null,
	loading: false,
	error: null,
	apartmentList: null,
	compatCount: null,
	daycareCount: null,
	boardingCount: null,
	autoCaps: [],
	service_page_loading: false,
	selectedKennelFilters: {
		standard_kennel: false,
		luxury_kennel: false,
		'standard-shared': false,
		'luxury-shared': false,
		kennel_free: false,
		kennel_assigned: false,
		kennel_unassigned: false
	},
	kennelfilters: {
		standard_kennel: {
			value: 'standard_kennel',
			label: 'Standard Kennel'
		},
		luxury_kennel: {
			value: 'luxury_kennel',
			label: 'Luxury Kennel'
		},
		'standard-shared': {
			value: 'standard-shared',
			label: 'Standard-Shared'
		},
		'luxury-shared': {
			value: 'luxury-shared',
			label: 'Luxury-Shared'
		},
		kennel_free: {
			value: 'kennel_free',
			label: 'Kennel Free'
		},
		kennel_assigned: {
			value: 'kennel_assigned',
			label: 'Kennel Assigned'
		},
		kennel_unassigned: {
			value: 'kennel_unassigned',
			label: 'Kennel Unassigned'
		}
	},
	selectedPlaygroupsFilters: {
		type: [],
		kennel_block: [],
		indoor_play_area: [],
		outdoor_play_area: [],
		status: []
	},
	playgroupsFilters: {
		type: [],
		kennel_block: [],
		indoor_play_area: [],
		outdoor_play_area: [],
		status: Object.entries(PLAYGROUP_STATUSES).map(([value, label]) => ({ value, label }))
	},
	selectedKennelsFilters: {
		area: [],
		kennel_block: [],
		type: [],
		status: []
	},
	kennelsFilters: {
		area: [],
		kennel_block: [],
		type: [],
		status: Object.entries(KENNEL_STATUSES).map(([value, label]) => ({ value, label }))
	},
	training: {}
}

const facilities = (state = initialState, action) => {
	switch (action.type) {
		case 'UPDATE_PLAYGROUPS_STATUS': {
			const ids = action.payload.playgroups.map((p) => p._id)
			return {
				...state,
				selected: {
					...state.selected,
					playgroups: state.selected.playgroups.map((p) => {
						if (ids.includes(p._id)) {
							return {
								...p,
								status: 'in use'
							}
						}

						return p
					})
				}
			}
		}

		case 'RESET_APP':
			return { ...initialState }
		case 'SET_SELECTED_KENNEL_FILTERS':
			return { ...state, selectedKennelFilters: action.payload }
		case 'SET_SELECTED_KENNELS_FILTERS':
			return { ...state, selectedKennelsFilters: action.payload }
		case 'SET_SELECTED_PLAYGROUPS_FILTERS':
			return { ...state, selectedPlaygroupsFilters: action.payload }
		case 'UPDATE_ADDON_TYPE': {
			const newAdds = state.selected.add_on_services_mapped.map((a) => {
				if (a._id === action.payload._id) return action.payload
				return a
			})

			let featured_addons = state.selected.featured_addons || []
			if (action.payload.isCurrentlyFeatured) {
				const { newId, _id } = action.payload
				featured_addons = featured_addons?.map((featured) => {
					if (featured.addon_id === _id) {
						featured.addon_id = newId
					}
					return featured
				})
			}

			const newAddsGrouped = _.groupBy(newAdds, 'type')

			return {
				...state,
				selected: {
					...state.selected,
					addOnTypes: state.selected.addOnTypes.map((a) => {
						if (a._id === action.payload._id) return action.payload

						return a
					}),
					add_on_services: newAddsGrouped,
					add_on_services_mapped: newAdds,
					featured_addons
				}
			}
		}
		case 'UPDATEMANY_ADDON_SUCCESS': {
			const category = action.payload[0].type
			const newAddOns = {
				...state.selected.add_on_services,
				[category]: action.payload
			}

			const add_on_services_mapped = state.selected.add_on_services_mapped.map((a) => {
				const findUpdated = action.payload.find((add) => add._id === a._id)
				if (findUpdated) return findUpdated
				return a
			})

			return {
				...state,
				loading: false,
				selected: {
					...state.selected,
					add_on_services: newAddOns,
					add_on_services_mapped
				}
			}
		}
		case 'CREATE_ADDON_TYPE': {
			const newAddsArr = [...state.selected.add_on_services_mapped, action.payload]

			const newAddsGrouped = _.groupBy(newAddsArr, 'type')

			return {
				...state,
				selected: {
					...state.selected,
					add_on_services_mapped: newAddsArr,
					add_on_services: newAddsGrouped,
					addOnTypes: newAddsArr
				}
			}
		}
		case 'SAVE_AREA': {
			return {
				...state,
				selected: {
					...state.selected,
					playgroups: state.selected.playgroups.map((g) => {
						return {
							...g,
							area_id: g._id === action.payload.group._id ? action.payload.area._id : g.area_id
						}
					})
				}
			}
		}
		case 'ASSIGN_KENNELS': {
			// { type: 'ASSIGN_KENNELS', payload: { playgroup_id, facilityId, kennels }}
			const obj = {
				...state,
				selected: {
					...state.selected,
					playgroups: state.selected.playgroups.map((p) => {
						return {
							...p,
							kennels: p._id === action.payload.playgroup_id ? action.payload.kennels : p.kennels
						}
					})
				}
			}

			return obj
		}
		case 'UPDATE_HOLIDAYS': {
			return {
				...state,
				selected: {
					...state.selected,
					holidays: action.payload
				}
			}
		}
		case 'SET_STAFF': {
			// 'SET_STAFF', payload: { time, staff: arr, playgroup_id }

			let selectedGroup
			if (state.selected_playgroup && state.selected_playgroup._id == action.payload.playgroup_id) {
				selectedGroup = {
					...state.selected_playgroup,
					staff: {
						...state.selected_playgroup.staff,
						[action.payload.time]: action.payload.staff
					}
				}
			} else {
				selectedGroup = state.selected_playgroup
			}

			return {
				...state,
				selected_playgroup: selectedGroup,
				selected: {
					...state.selected,
					playgroups: state.selected.playgroups.map((group) => {
						if (group._id === action.payload.playgroup_id) {
							return {
								...group,
								staff: {
									...group.staff,
									[action.payload.time]: action.payload.staff
								}
							}
						} else {
							return group
						}
					})
				}
			}
		}
		case 'SET_GROUP': {
			return {
				...state,
				selected_playgroup: action.payload
			}
		}
		case 'GET_FACILITIES':
			return { ...state, loading: true }
		case 'GET_FACILITIES_SUCCESS':
			return {
				...state,
				loading: false,
				facilities: action.payload.facilities,
				staff: action.payload.staff,
				training: action.payload.facilities.reduce((acc, facility) => {
					acc[facility._id] = {}
					return acc
				}, {})
			}
		case 'RELOAD_FACILITIES_SUCCESS': {
			let selected
			if (state.selected) {
				let f = action.payload.facilities.find((fac) => fac._id === state.selected._id)
				selected = f || state.selected
			}

			return {
				...state,
				selected: selected || state.selected,
				loading: false,
				facilities: action.payload.facilities,
				staff: action.payload.staff
			}
		}
		case 'GET_FACILITIES_FAIL':
			return {
				...state,
				loading: false,
				error: 'Error while fetching repositories'
			}
		case 'SET_SELECTED_FACILITY': {
			if (!action.payload || !action.payload._id) return state

			const selectedFromList = (state.facilities || []).find(
				(facility) => String(facility._id) === String(action.payload._id)
			)

			return {
				...state,
				selected: selectedFromList || action.payload,
				compatCount: null
			}
		}
		case 'GET_APARTMENT_LIST':
			return { ...state, loading: true }
		case 'GET_APARTMENTS_SUCCESS':
			return {
				...state,
				loading: false,
				apartmentList: action.payload.sort((a, b) => (a.name > b.name ? 1 : -1))
			}
		case 'GET_APARTMENTS_FAIL':
			return {
				...state,
				loading: false,
				error: 'Error while fetching apartments'
			}
		case 'UPDATE_FACILITY':
			return { ...state, loading: true, error: null }
		case 'UPDATE_FACILITY_SUCCESS':
			// Never invent a partial selected (e.g. advancedSettings GET racing App restore).
			if (!state.selected || !state.selected._id) {
				return {
					...state,
					loading: false,
					error: null
				}
			}

			return {
				...state,
				selected: {
					...state.selected,
					...action.payload
				},
				loading: false,
				error: null
			}
		case 'UPDATE_FACILITY_FAIL':
			return {
				...state,
				loading: false,
				error: 'An error occured while updating the select facility.'
			}
		case 'GET_AGGREGATED_VISITS_COUNT':
			return { ...state, loading: true }
		case 'ADD_AUTOCAP': {
			return {
				...state,
				capacity: {
					...state.capacity,
					[action.payload.date_string]: {
						...state.capacity[action.payload.date_string],
						autoCaps: [...state.capacity[action.payload.date_string].autoCaps, action.payload]
					}
				}
			}
		}
		case 'SERVICES_LOADING': {
			return {
				...state,
				loading: true
			}
		}
		case 'REMOVE_AUTOCAP': {
			return {
				...state,
				capacity: {
					...state.capacity,
					[action.payload.date_string]: {
						...state.capacity[action.payload.date_string],
						autoCaps: state.capacity[action.payload.date_string].autoCaps.filter(
							(ac) => ac._id !== action.payload._id
						)
					}
				}
				// loading: false,
				// service_page_loading: false
			}
		}
		case 'SERVICE_PAGE_LOADING': {
			return {
				...state,
				service_page_loading: true
			}
		}
		case 'SERVICE_PAGE_NOT_LOADING': {
			return {
				...state,
				service_page_loading: false
			}
		}
		case 'GET_AGGREGATED_VISITS_SUCCESS':
			const newState = {
				...state,
				service_page_loading: false,
				capacity: {
					...action.payload
				}
			}

			return newState

		case 'GET_COUNT_FAILED':
			return {
				...state,
				loading: false,
				error: 'An error occured while getting the visit counts'
			}
		case 'GET_FACILITY_TRAINING':
			return { ...state, loading: true }
		case 'SET_FACILITY_LOADING':
			return { ...state, loading: action.payload }
		case 'GET_FACILITY_TRAINING_SUCCESS': {
			return { ...state, loading: false }
		}
		case 'GET_FACILITY_TRAINING_FAILED': {
			return {
				...state,
				loading: false,
				error: action.payload
			}
		}
		case 'SET_FACILITY_TRAINING': {
			const { data = [], trainingKey, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						[trainingKey]: data
					}
				}
			}
		}

		case 'UPDATE_FACILITY_TRAINING_CALENDAR_FVRT_SESSION': {
			if (!state.training[action.payload.facility_id]?.calendar) {
				return state
			}

			const { date, _id, facility_id, update } = action.payload

			const updatedCalendar = { ...state.training[facility_id].calendar }
			updatedCalendar[date] = updatedCalendar[date].map((session) => {
				if (session._id === _id) {
					return {
						...session,
						...update
					}
				}
				return session
			})

			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facility_id]: {
						...state.training[facility_id],
						calendar: updatedCalendar
					}
				}
			}
		}

		case 'UPDATE_FACILITY_TRAINING_SCHEDULE_ATTENDANCE': {
			if (!state.training[action.payload.facilityId]?.schedule) {
				return state
			}
			const { facilityId, attendanceId, status } = action.payload

			const updatedSchedule = state.training[facilityId].schedule.map((schedule) => {
				if (schedule._id === attendanceId) {
					return {
						...schedule,
						status
					}
				} else {
					return schedule
				}
			})

			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						schedule: updatedSchedule
					}
				}
			}
		}
		case 'ADD_FACILITY_TRAINING_LOCATION': {
			const { location, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						locations: state.training[facilityId].locations
							? [...state.training[facilityId].locations, ...location]
							: [...location]
					}
				}
			}
		}
		case 'UPDATE_FACILITY_TRAINING_LOCATION': {
			const { location_id, update, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						locations: state.training[facilityId].locations
							? update.deactivated
								? state.training[facilityId].locations.filter((loc) => loc._id !== location_id)
								: state.training[facilityId].locations.map((loc) => {
										if (loc._id === location_id) {
											return {
												...update
											}
										}
										return loc
								  })
							: []
					}
				}
			}
		}
		case 'ADD_FACILITY_TRAINING_COURSE': {
			const { course, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						courses: state.training[facilityId].courses
							? [...state.training[facilityId].courses, ...course]
							: [...course]
					}
				}
			}
		}

		case 'NEW_FACILITY_TRAINING_CLASS': {
			const { trainingClass, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						classes: state.training[facilityId].classes
							? { ...state.training[facilityId].classes, [trainingClass._id]: trainingClass }
							: { [trainingClass._id]: trainingClass }
					}
				}
			}
		}

		case 'ADD_FACILITY_TRAINING_CLASS': {
			const { trainingClass, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						classes: state.training[facilityId].classes
							? { ...state.training[facilityId].classes, [trainingClass._id]: trainingClass }
							: { [trainingClass._id]: trainingClass }
					}
				}
			}
		}

		case 'UPDATE_FACILITY_TRAINING_CLASS': {
			const { _id, update, facilityId } = action.payload

			if (!state.training[facilityId]?.classes || !state.training[facilityId].classes[_id]) {
				return state
			}

			const updatedClasses = { ...state.training[facilityId].classes }

			if (update.deactivated) {
				delete updatedClasses[_id]
			}

			updatedClasses[_id] = { ...updatedClasses[_id], ...update }

			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						classes: updatedClasses
					}
				}
			}
		}

		case 'UPDATE_FACILITY_TRAINING_CLASS_SESSION_ATTENDANCE': {
			const { session, attendanceId, facilityId, classId } = action.payload

			if (!state.training[facilityId]?.classes || !state.training[facilityId].classes[classId]) {
				return state
			}

			const updatedClass = { ...state.training[facilityId].classes[classId] }
			const updatedSession = updatedClass.attendance_by_session[session - 1]
			updatedSession.attendance = updatedSession.attendance.map((attendance) => {
				if (attendance._id === attendanceId) {
					return {
						...attendance,
						status: action.payload.status
					}
				}
				return attendance
			})
			updatedClass.attendance_by_session[session - 1] = updatedSession

			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						classes: {
							...state.training[facilityId].classes,
							[classId]: updatedClass
						}
					}
				}
			}
		}

		case 'UPDATE_FACILITY_TRAINING_COURSE': {
			const { course_id, update, facilityId } = action.payload
			return {
				...state,
				loading: false,
				training: {
					...state.training,
					[facilityId]: {
						...state.training[facilityId],
						courses: state.training[facilityId].courses
							? update.deactivated
								? state.training[facilityId].courses.filter((course) => course._id !== course_id)
								: state.training[facilityId].courses.map((course) => {
										if (course._id === course_id) {
											return {
												...update
											}
										}
										return course
								  })
							: []
					}
				}
			}
		}

		case 'AUTO_ASSIGN_CUBBIES_FAILED': {
			return { ...state, loading: false }
		}

		case 'AUTO_ASSIGN_CUBBIES_SUCCEEDED': {
			return { ...state, loading: false }
		}

		default:
			return state
	}
}

export default facilities
